import assign from 'lodash/assign';
import ngFocusIf from 'ng-focus-if';

import { CheckoutService } from 'services/checkout.service';
import { ApiService } from 'services/api.service';
import { ShopperAccountService } from 'services/shopperAccount.service';
import { AuthService } from 'services/auth.service';
import { LimitInputLength } from 'directives/limitInputLength.directive';

import template from './forgotPassword.html';

export const ForgotPassword = angular
    .module('checkout.components.loginModal.forgotPassword', [
        ngFocusIf,
        CheckoutService,
        ApiService,
        ShopperAccountService,
        AuthService,
        LimitInputLength
    ]).component('forgotPassword', {
        template,
        bindings: {
            onCancelClicked: '&',
            email: '<'
        },
        controller: class ForgotPasswordCtrl {
            constructor(checkoutService, apiService, shopperAccountService, authService, $mdDialog) {
                assign(this, {
                    checkoutService,
                    apiService,
                    shopperAccountService,
                    authService,
                    $mdDialog,
                    showCodeInput: false,
                    showEmailInput: true
                });
            }

            onFormSubmit() {
                if (this.showEmailInput) {
                    this.onSendEmailClicked();
                } else if (this.showCodeInput) {
                    this.onConfirmCodeClicked();
                } else if (this.showNewPasswordForm) {
                    this.onConfirmNewPasswordClicked();
                }
            }

            onSendEmailClicked() {
                if (this.forgotPasswordForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.forgotPasswordForm);
                    return;
                }

                this.sendingEmail = true;
                this.apiService.account.sendPasswordResetEmail(this.email)
                    .then(() => {
                        this.showEmailInput = false;
                        this.showCodeInput = true;
                    }).catch(() => {
                        this.errorMessage = 'Could not send email';
                    }).finally(() => {
                        this.sendingEmail = false;
                    });
            }

            onConfirmCodeClicked() {
                if (this.forgotPasswordForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.forgotPasswordForm);
                    return;
                }

                this.confirmingCode = true;
                this.apiService.account.verifyResetPasswordCode(this.email, this.code)
                    .then(() => {
                        this.showCodeInput = false;
                        this.showNewPasswordForm = true;
                    }).catch(() => {
                        this.errorMessage = 'Could not verify code';
                    }).finally(() => {
                        this.confirmingCode = false;
                    });
            }

            onConfirmNewPasswordClicked() {
                if (this.forgotPasswordForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.forgotPasswordForm);
                    return;
                }

                this.updatingPassword = true;
                this.apiService.account.updatePassword(this.email, this.password, this.code)
                    .then(() => {
                        return this.authService.login(this.email, this.password).then(() => {
                            return this.shopperAccountService.initShopperAccount()
                                .then(data => this.$mdDialog.hide(data));
                        });
                    }).catch(() => {
                        this.updatingPassword = false;
                        this.errorMessage = 'Could not update password';
                    });
            }

            onDidNotGetEmailClick() {
                this.apiService.account.sendPasswordResetEmail(this.email)
                    .then(() => {
                        this.showEmailResentMessage = true;
                    }).catch(() => {
                        this.errorMessage = 'Could not send email';
                    });
            }

            onCloseButtonClicked() {
                this.$mdDialog.cancel();
            }

            onTogglePasswordVisibilityClick() {
                this.showPassword = !this.showPassword;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/loginModal/forgotPassword/forgotPassword.js